<template>
    <div class="v-application vuetify-wrapper" data-test="steffi-team-users">
        <v-row>
            <v-col cols="12" lg="4">
                <v-card outlined>
                    <v-card-title>Steffi-Team Zugang anlegen</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="form.firstname" label="Vorname" outlined dense data-test="steffi-team-firstname"></v-text-field>
                        <v-text-field v-model="form.lastname" label="Nachname" outlined dense data-test="steffi-team-lastname"></v-text-field>
                        <v-text-field v-model="form.email" label="E-Mail" type="email" outlined dense data-test="steffi-team-email"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" :disabled="!canCreate" :loading="isCreating" data-test="steffi-team-create" @click="createAccount">
                            Zugang anlegen
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="12" lg="8">
                <v-card outlined>
                    <v-card-title>
                        Steffi-Team
                        <v-spacer></v-spacer>
                        <v-btn icon :loading="isLoading" @click="fetchAccounts"><v-icon>mdi-refresh</v-icon></v-btn>
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="accounts"
                        :loading="isLoading"
                        item-key="id"
                        no-data-text="Keine Steffi-Team Zugänge"
                        :footer-props="{ 'items-per-page-text': 'Zeilen pro Seite' }"
                    >
                        <template v-slot:item.active="{ item }">
                            <v-chip small :color="item.active ? 'success' : 'grey'" text-color="white">
                                {{ item.active ? 'Aktiv' : 'Deaktiviert' }}
                            </v-chip>
                        </template>
                        <template v-slot:item.created="{ item }">
                            {{ item.created ? $formatDate(item.created, 'DD.MM.YYYY HH:mm') : '-' }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn small text color="primary" :disabled="!item.active" :loading="busyId === `mail-${item.id}`"
                                data-test="steffi-team-resend" @click="resendPasswordSetup(item)">
                                Einrichtungslink senden
                            </v-btn>
                            <v-btn small text :color="item.active ? 'error' : 'success'" :loading="busyId === `active-${item.id}`"
                                data-test="steffi-team-toggle-active" @click="setActive(item, !item.active)">
                                {{ item.active ? 'Deaktivieren' : 'Reaktivieren' }}
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import { mapMutations } from 'vuex';

export default {
    data: () => ({
        accounts: [],
        isLoading: false,
        isCreating: false,
        busyId: null,
        form: { firstname: '', lastname: '', email: '' },
        headers: [
            { text: 'Name', value: 'fullname' },
            { text: 'E-Mail', value: 'email' },
            { text: 'Status', value: 'active' },
            { text: 'Erstellt', value: 'created' },
            { text: '', value: 'actions', sortable: false },
        ],
    }),
    computed: {
        canCreate() {
            return Boolean(this.form.firstname && this.form.lastname && this.form.email && !this.isCreating);
        },
    },
    created() {
        this.fetchAccounts();
    },
    methods: {
        async fetchAccounts() {
            try {
                this.isLoading = true;
                const response = await axios.get('/api/steffi/team-users');
                this.accounts = response.data.items || [];
            } catch (error) {
                this.alertError('Steffi-Team Zugänge konnten nicht geladen werden.');
            } finally {
                this.isLoading = false;
            }
        },
        async createAccount() {
            if (!this.canCreate) return;
            try {
                this.isCreating = true;
                const response = await axios.post('/api/steffi/team-users', this.form);
                this.accounts.unshift(response.data.account);
                this.form = { firstname: '', lastname: '', email: '' };
                this.alertSuccess('Zugang wurde angelegt und der Einrichtungslink versendet.');
            } catch (error) {
                const account = error?.response?.data?.account;
                if (account && !this.accounts.some(item => item.id === account.id)) this.accounts.unshift(account);
                this.alertError(error?.response?.data?.message || 'Zugang konnte nicht angelegt werden.');
            } finally {
                this.isCreating = false;
            }
        },
        async resendPasswordSetup(item) {
            this.busyId = `mail-${item.id}`;
            try {
                await axios.post(`/api/steffi/team-users/${item.id}/password-reset`);
                this.alertSuccess('Einrichtungslink wurde versendet.');
                await this.fetchAccounts();
            } catch (error) {
                this.alertError(error?.response?.data?.message || 'Einrichtungslink konnte nicht versendet werden.');
            } finally {
                this.busyId = null;
            }
        },
        async setActive(item, active) {
            this.busyId = `active-${item.id}`;
            try {
                const response = await axios.put(`/api/steffi/team-users/${item.id}/active`, { active });
                Object.assign(item, response.data.account);
                this.alertSuccess(active ? 'Zugang wurde reaktiviert.' : 'Zugang wurde deaktiviert.');
            } catch (error) {
                this.alertError(error?.response?.data?.message || 'Status konnte nicht geändert werden.');
            } finally {
                this.busyId = null;
            }
        },
        ...mapMutations({ alertError: 'alert/error', alertSuccess: 'alert/success' }),
    },
};
</script>
